module.exports = __webpack_public_path__ + "img/logo.f2cf02c1.png";